import { TextLayer } from "@deck.gl/layers"
import type { DefaultProps } from "@deck.gl/core"
import { VideoMetadata } from "@nova/slice-video"

const defaultProps: DefaultProps = {
    pickable: false,
    getText: () => "+",
    getPosition: (d: VideoMetadata) => {
        return d.slice(0, 2)
    },
    getColor: [85, 140, 247, 255],
    getBorderColor: [255, 255, 255, 255],
    getBorderWidth: 1,
    sizeUnits: "pixels",
    getAngle: (d: VideoMetadata) => {
        return -d[2]
    },
    getSize: 20,
    visible: true,
    billboard: false,
    fontSettings: {
        sdf: true,
        fontSize: 128,
    },
}

export default class VideoCrosshairLayer extends TextLayer {
    static defaultProps = defaultProps
    static layerName = "VideoPathsLayer"
}
